import PropTypes from "prop-types";
import React from "react";
import { Button } from "semantic-ui-react";
import SectionMenu from "shared/components/unit/SectionMenu";
import Configurator from "shared/components/configurator/Configurator";
import LineItemList from "./LineItemList";
import CatalogPage from "./CatalogPage";

import "./sectionPage.scss";

class SectionPage extends React.Component {
  static propTypes = {
    i18n: PropTypes.object,
    user: PropTypes.object,
    actions: PropTypes.object,
    pageName: PropTypes.string,
    unitPath: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { section } = this.props;

    return (
      <div data-component="section">
        <CatalogPage>
          {this.renderConfigurator(section)}
          {(section.isRoot && this.renderSectionMenu()) ||
            this.renderLineItems(section)}
        </CatalogPage>
      </div>
    );
  }

  renderSectionMenu() {
    const { unitPath } = this.props;
    return <SectionMenu unitPath={unitPath} />;
  }

  renderLineItems(section) {
    if (section) {
      return (
        <div data-component="lineItemsGroup">
          <LineItemList sectionId={section.id} />
        </div>
      );
    }
  }

  renderConfigurator(section) {
    if (section.configuratorId) {
      return (
        <div data-component="configuratorTrigger">
          <Configurator
            configuratorId={section.configuratorId}
            trigger={<Button icon="cube" content="3D Konfigurator" basic />}
          />
        </div>
      );
    }
  }
}

export default SectionPage;
